import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../../styles/NavBar.css";
import Logout from "../Registration/LogOut";
import {
  getCurrentUser,
  isLoggedIn as checkLogin,
} from "../../utility/UserUtils";

const NavBar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(checkLogin());
  const [user, setUser] = useState(getCurrentUser());

  const links = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About Us" },
    { to: "/events", label: "Events" },
    { to: "/blogs", label: "Blogs" },
    { to: "/referral", label: "Referral" },
   // { to: "/gallery", label: "Gallery" },
    { to: "/contactus", label: "Contact Us" },
  ];

  useEffect(() => {
    const updateAuth = () => {
      setIsLoggedIn(checkLogin());
      setUser(getCurrentUser());
    };

    const resize = () => window.innerWidth > 1024 && setMenuOpen(false);

    window.addEventListener("authChange", updateAuth);
    window.addEventListener("resize", resize);

    return () => {
      window.removeEventListener("authChange", updateAuth);
      window.removeEventListener("resize", resize);
    };
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }) => "nav-link" + (isActive ? " active" : "");

  const navLinks = links.map(({ to, label }) => (
    <NavLink
      key={to}
      to={to}
      className={linkClass}
      end={to === "/"}
      onClick={() => setMenuOpen(false)}
    >
      {label}
    </NavLink>
  ));

  const signUpLink = !isLoggedIn && (
    <NavLink
      to="/signup"
      className={({ isActive }) =>
        "nav-link signup-link" + (isActive ? " active" : "")
      }
      onClick={() => setMenuOpen(false)}
    >
      SIGN UP
    </NavLink>
  );

  const authButton = isLoggedIn ? (
    <div className="profile-section">
      {user?.avatar?.url ? (
        <img
          src={user.avatar.url}
          alt={user.name || "Profile"}
          className="nav-avatar"
          onClick={() => handleNavigate("/profile")}
        />
      ) : (
        <button
          className="btn-login"
          onClick={() => handleNavigate("/profile")}
        >
          {user?.name || "Profile"}
        </button>
      )}
      <Logout />
    </div>
  ) : (
    <button
      className="btn-login"
      onClick={() => handleNavigate("/login")}
      aria-label="Login"
    >
      Login
    </button>
  );

  return (
    <nav>
      <div
        className="logo"
        onClick={() => handleNavigate("/")}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && handleNavigate("/")}
        aria-label="Navigate to home"
      >
        <img src="/assets/images/wiselogo.png" alt="WISE Logo" />
      </div>

      <div className="nav-links">{navLinks}</div>

      <div className="right-buttons">
        {signUpLink}
        {authButton}
      </div>

      <div
        className={`hamburger${menuOpen ? " open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
        role="button"
        tabIndex={0}
        aria-label="Toggle menu"
        onKeyDown={(e) => e.key === "Enter" && setMenuOpen(!menuOpen)}
      >
        <div></div>
        <div></div>
        <div></div>
      </div>

      <div className={`mobile-menu${menuOpen ? " open" : ""}`}>
        {navLinks}
        {signUpLink}
        {authButton}
      </div>
    </nav>
  );
};

export default NavBar;
